import { Button, Card, Col, ConfigProvider, Form, Input, Row, Select } from 'antd';
import { useEffect, useState } from 'react';

const FlowContainer: React.FC<any> = (props) => {
  const [data, setData] = useState([]);
  const { property } = props;
  const {
    dataSource: { mockData },
    fontColor,
    edgeColor,
    h,
  } = property;

  const markerSize = 16;
  const circleSize = 6;

  useEffect(() => {
    const result = JSON.parse(mockData).reduce((acc, cur) => {
      const getDataOption = () => {
        if (cur.dataOption.indexOf('|') > -1) {
          const groups = cur.dataOption.split('|').map((item) => item.trim());
          const options = groups.reduce((acc, cur) => {
            const [title, list] = cur.split(':');
            const option = {
              label: <span>{title}</span>,
              title,
              options: list.split(',').map((item) => ({ label: item, value: item.trim() })),
            };
            acc.push(option);
            return acc;
          }, []);
          return options;
        } else {
          return cur.dataOption.split(',').map((dataValue) => ({
            key: `${cur.title}_${dataValue}`,
            label: dataValue,
            value: dataValue.trim(),
          }));
        }
      };
      const data = {
        title: cur.title,
        assigneeOption: cur.assigneeOption.split(',').map((assignee) => ({
          key: `${cur.title}_${assignee}`,
          label: assignee,
          value: assignee.trim(),
        })),
        assigneeDefault: cur.assigneeDefault.trim(),
        dataOption: getDataOption(),
        dataDefault: cur.dataDefault.split(',').map((dataValue) => dataValue.trim()),
        engineOption: cur.engineOption.split(',').map((engine) => ({
          key: `${cur.title}_${engine}`,
          label: engine,
          value: engine.trim(),
        })),
        engineDefault: cur.engineDefault.split(',').map((dataValue) => dataValue.trim()), //  cur.engineDefault.trim(),
      };
      acc.push(data);
      return acc;
    }, []);
    setData(result);
    console.log(property);
  }, [property]);

  const getSize = (type) => {
    if (!document.querySelector('.flow-container')) {
      return 0;
    }
    const containerWidth = document.querySelector('.flow-container').clientWidth;
    const containerHeight = document.querySelector('.flow-container').clientHeight;
    const cardBodyWidth = containerWidth / 4;
    const cardBodyHeight = containerHeight / 2.4;

    return { containerWidth, containerHeight, cardBodyWidth, cardBodyHeight }[type];
  };

  const getCardPos = (type) => {
    if (!document.querySelector('.flow-container')) {
      return {};
    }
    const containerWidth = document.querySelector('.flow-container').clientWidth;
    const containerHeight = document.querySelector('.flow-container').clientHeight;
    const card1Pos = { left: containerWidth / 2 - getSize('cardBodyWidth') / 2, top: 0 };
    const card2Pos = { right: 0, top: containerHeight / 2 - getSize('cardBodyHeight') / 2 };
    const card3Pos = { left: containerWidth / 2 - getSize('cardBodyWidth') / 2, bottom: 0 };
    const card4Pos = { top: containerHeight / 2 - getSize('cardBodyHeight') / 2 };
    return { card1Pos, card2Pos, card3Pos, card4Pos }[type];
  };

  const getEdgePos = (type) => {
    if (!document.querySelector('.flow-container')) {
      return [];
    }
    const containerWidth = document.querySelector('.flow-container').clientWidth;
    const containerHeight = document.querySelector('.flow-container').clientHeight;
    const edge1Pos = [
      getSize('cardBodyWidth'),
      containerHeight / 2 - getSize('cardBodyHeight') * 0.3,
      containerWidth / 2 - getSize('cardBodyWidth') / 2,
      getSize('cardBodyHeight') * 0.3,
    ];
    const edge2Pos = [
      getSize('cardBodyWidth'),
      containerHeight / 2 + getSize('cardBodyHeight') * 0.3,
      containerWidth / 2 - getSize('cardBodyWidth') / 2,
      containerHeight - getSize('cardBodyHeight') * 0.3,
    ];
    const edge3Pos = [
      containerWidth / 2 + getSize('cardBodyWidth') / 2,
      getSize('cardBodyHeight') * 0.3,
      containerWidth - getSize('cardBodyWidth'),
      containerHeight / 2 - getSize('cardBodyHeight') * 0.3,
    ];
    const edge4Pos = [
      containerWidth / 2 + getSize('cardBodyWidth') / 2,
      containerHeight - getSize('cardBodyHeight') * 0.3,
      containerWidth - getSize('cardBodyWidth'),
      containerHeight / 2 + getSize('cardBodyHeight') * 0.3,
    ];
    return { edge1Pos, edge2Pos, edge3Pos, edge4Pos }[type];
  };

  const cardStyles = {
    cover: { background: 'rgba(0,0,0,0)' },
    header: { minHeight: 30, color: fontColor },
    body: { width: getSize('cardBodyWidth'), height: getSize('cardBodyHeight'), display: 'flex', alignItems: 'center' },
  };

  const pathProperty = {
    stroke: edgeColor,
    strokeWidth: 2,
    fill: 'none',
    style: {
      markerStart: 'url(#circle)',
      markerEnd: 'url(#triangle)',
    },
  };

  const getD = (params) => {
    console.log(params);
    const [startX, startY, endX, endY] = params;
    const X1 = startX + ((endX - startX) / 2 + 10);
    const Y1 = startY;
    const X2 = endX - ((endX - startX) / 2 + 10);
    const Y2 = endY;
    // M 300 200 C 360 200 340 100 400 100
    return `M ${startX + circleSize} ${startY} C ${X1} ${Y1} ${X2} ${Y2} ${endX - markerSize} ${endY}`;
  };

  return (
    <>
      <div className="flow-container" style={{ position: 'relative', height: '100%' }}>
        {data.map(({ title, assigneeOption, assigneeDefault, dataOption, dataDefault, engineOption, engineDefault }, index) => (
          <div style={{ position: 'absolute', ...getCardPos(`card${index + 1}Pos`) }}>
            <Card title={title} style={{ background: 'rgba(2, 2, 2, 0.4)' }} styles={cardStyles}>
              <ConfigProvider
                theme={{
                  components: {
                    Form: {
                      labelColor: fontColor,
                      labelFontSize: 16,
                      itemMarginBottom: 24 * (h / 24),
                    },
                    Button: { defaultBg: 'rgba(0,0,0,0)', defaultColor: fontColor },
                    Card: {
                      headerFontSize: 18,
                    },
                    Tag: {
                      defaultColor: fontColor,
                    },
                  },
                }}
              >
                <Form
                  labelAlign="right"
                  layout={'horizontal'}
                  style={{ width: '100%' }}
                  size="small"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                >
                  <Row>
                    <Col span={20}>
                      <Form.Item className="form-item-label-right" label="Agent" style={{ color: fontColor }}>
                        <Select options={assigneeOption} defaultValue={assigneeDefault} />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Button style={{ marginLeft: 5 }}>設定</Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={20}>
                      <Form.Item className="form-item-label-right" label="Data" style={{ color: fontColor }}>
                        <Select
                          mode="multiple"
                          // maxTagCount="responsive"
                          options={dataOption}
                          defaultValue={dataDefault}
                          tagRender={(props) => {
                            return (
                              <span title={props.value} style={{ marginLeft: 5 }}>
                                {props.label}
                              </span>
                            );
                          }}
                          className="select-multiple-h-70"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={20}>
                      <Form.Item className="form-item-label-right" label="Engine" style={{ color: fontColor }}>
                        {/* <Select options={engineOption} defaultValue={engineDefault} /> */}
                        <Select
                          mode="multiple"
                          // maxTagCount="responsive"
                          options={engineOption}
                          defaultValue={engineDefault}
                          tagRender={(props) => {
                            return (
                              <span title={props.value} style={{ marginLeft: 5 }}>
                                {props.label}
                              </span>
                            );
                          }}
                          className="select-multiple-h-70"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Button style={{ marginLeft: 5 }}>設定</Button>
                    </Col>
                  </Row>
                </Form>
              </ConfigProvider>
            </Card>
          </div>
        ))}
        <svg width="100%" height="100%" xmlns="http://wwww.w3.org/2000/svg">
          <defs>
            <marker
              id="triangle"
              markerUnits="strokeWidth"
              markerWidth={markerSize}
              markerHeight={markerSize}
              refX="0"
              refY="3"
              orient="auto"
            >
              <path d="M 0 0 L 6 3 L 0 6 M 0 3 L 6 3" fill="none" stroke={edgeColor} />
            </marker>
          </defs>
          <defs>
            <marker id="circle" markerWidth="8" markerHeight="8" refX="3" refY="3" orient="auto">
              <circle cx="4" cy="4" r="2" stroke={edgeColor} fill={edgeColor} stroke-width="1" />
            </marker>
          </defs>
          <path d={getD(getEdgePos('edge1Pos'))} {...pathProperty} />
          <path d={getD(getEdgePos('edge2Pos'))} {...pathProperty} />
          <path d={getD(getEdgePos('edge3Pos'))} {...pathProperty} />
          <path d={getD(getEdgePos('edge4Pos'))} {...pathProperty} />
        </svg>
      </div>
    </>
  );
};

export default FlowContainer;
